module.exports = __webpack_public_path__ + "static/media/385SunsetAveNW_2018-06-11_156.13867c79.jpg";